import { useEffect } from "react";

const DEFAULTS = {
  title: "Houses7.com | Buy, Rent, PG & Commercial Property",
  description:
    "Buy, rent or list homes, PGs, plots and commercial property across India. Real photos, verified owners and instant enquiry alerts.",
  image: "/og-cover.png",
};

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, key, val] = selector.match(/\[(.+?)="(.+?)"\]/) || [];
    if (key && val) el.setAttribute(key, val);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

// Per-page title, description, canonical, social tags and optional JSON-LD.
export const useSeo = ({ title, description, image, path, jsonLd, noindex = false } = {}) => {
  useEffect(() => {
    const t = title ? `${title} | Houses7.com` : DEFAULTS.title;
    const d = description || DEFAULTS.description;
    const origin = window.location.origin;
    const url = `${origin}${path || window.location.pathname}`;
    const img = image ? (image.startsWith("http") ? image : `${origin}${image}`) : `${origin}${DEFAULTS.image}`;

    document.title = t;
    setMeta('meta[name="description"]', "content", d);
    setMeta('meta[property="og:title"]', "content", t);
    setMeta('meta[property="og:description"]', "content", d);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:image"]', "content", img);
    setMeta('meta[name="twitter:title"]', "content", t);
    setMeta('meta[name="twitter:description"]', "content", d);
    setMeta('meta[name="twitter:image"]', "content", img);
    setMeta('meta[name="robots"]', "content", noindex ? "noindex,nofollow" : "index,follow");
    setLink("canonical", url);

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => script?.remove();
  }, [title, description, image, path, noindex, JSON.stringify(jsonLd || null)]);
};

export default useSeo;
